<template>
    <div>
        <b-skeleton height="24px" width="180px"></b-skeleton>
        <b-skeleton height="19px" width="55px"></b-skeleton>
    </div>
</template>

<script>
import { BSkeleton } from 'bootstrap-vue';

export default {
    name: 'DataEntryColumnSkeleton',
    components: {
        BSkeleton
    }
}
</script>
